
export const SellerShop = new TypedDocumentString(`
    query SellerShop($handle: String!) {
  publicSeller(handle: $handle) {
    _id
    v1: _id
    productCount
    doc {
      ...SellerItemFull
      __typename
    }
    __typename
  }
}
    fragment SellerLink on SellerLink {
  alt
  type
  slug
  sellerId
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment SellerItem on SellerDoc {
  _id
  name
  handle
  logo {
    ...Image
    __typename
  }
  __typename
}
fragment SellerItemFull on SellerDoc {
  ...SellerItem
  _uiProfile {
    ...SellerProfile
    __typename
  }
  footerTxt {
    value
    __typename
  }
  contacts {
    ...SellerContacts
    __typename
  }
  message {
    ...SellerMessage
    __typename
  }
  homepage {
    _id
    __typename
  }
  aboutUs {
    _id
    __typename
  }
  cookiePolicy {
    _id
    __typename
  }
  shipping {
    _id
    __typename
  }
  returns {
    _id
    __typename
  }
  termsAndConditions {
    _id
    __typename
  }
  privacyPolicy {
    _id
    __typename
  }
  care {
    _id
    __typename
  }
  fabrics {
    _id
    __typename
  }
  certificate {
    _id
    __typename
  }
  warranty {
    _id
    __typename
  }
  off {
    isOff
    msg {
      value
      __typename
    }
    __typename
  }
  __typename
}
fragment OpeningHoursHour on OpeningHoursHour {
  hour
  min
  __typename
}
fragment OpeningHoursDay on OpeningHoursDay {
  open24
  close
  hours {
    open {
      ...OpeningHoursHour
      __typename
    }
    close {
      ...OpeningHoursHour
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerContacts on SellerContacts {
  emails
  tels
  openingHours {
    timezone
    mon {
      ...OpeningHoursDay
      __typename
    }
    tue {
      ...OpeningHoursDay
      __typename
    }
    wed {
      ...OpeningHoursDay
      __typename
    }
    thu {
      ...OpeningHoursDay
      __typename
    }
    fri {
      ...OpeningHoursDay
      __typename
    }
    sat {
      ...OpeningHoursDay
      __typename
    }
    sun {
      ...OpeningHoursDay
      __typename
    }
    __typename
  }
  links {
    type
    handle
    __typename
  }
  __typename
}
fragment SellerTextLink on SellerTextLink {
  text {
    value
    __typename
  }
  link {
    ...SellerLink
    __typename
  }
  __typename
}
fragment SellerMessage on SellerMessage {
  id
  items {
    ...SellerTextLink
    __typename
  }
  __typename
}
fragment SellerProfile on SellerProfile {
  _id
  sellerId
  publicName
  image {
    ...Image
    __typename
  }
  tel
  email
  title
  handle
  bio
  modelHeight
  modelBust
  modelWaist
  modelHip
  contacts {
    ...SellerContacts
    __typename
  }
  __typename
}`, {"hash":"f062fa6ec4ba1be2a462b516fec12538651e231247580de9c8cae2da0d2af19c"});